import Page from 'flarum/components/Page';

export default class u2diRedirectPage extends Page {
  oninit(vnode) {
    window.location.replace("/");
  }

  view() {

  }

}
